export default "__VITE_ASSET__hzP5Gx7l__"